import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import PageHeading from '../../components/page-heading'
import PasswordResetForm from '../../components/password-reset-form'
import ChangePasswordForm from '../../components/change-password-form'
import { ConsumerLoginButton } from '../../components/login-actions'
import { useQueryStringParameters } from '../../lib/query-string'

const ForgotPasswordPage = () => {
  const { username, code } = useQueryStringParameters()

  const passwordResetState = {
    step: 'password-reset',
    data: {
      heading: 'Forgot your password?',
      subheading: 'Enter your email address below and we will send a code to reset your password',
    },
  }

  const changePasswordState = {
    step: 'change-password',
    data: {
      heading: 'Change password',
      subheading: 'We have sent your reset password instructions via email.',
      username: username,
    },
  }

  const [state, setState] = useState(username ? changePasswordState : passwordResetState)

  const advanceToChangePasswordStep = ({ username, message }) => {
    setState({
      step: 'change-password',
      data: {
        heading: 'Change password',
        subheading: message,
        username: username,
      },
    })
  }

  const advanceToSuccessStep = ({ message }) => {
    setState({
      step: 'success',
      data: {
        heading: 'Password updated',
        subheading: message,
      },
    })
  }

  return (
    <Box mb={4}>
      <PageHeading
        heading={state.data.heading}
        subheading={state.data.subheading}
      />
      {state.step === 'password-reset' && (
        <PasswordResetForm
          onSuccess={advanceToChangePasswordStep}
        />
      )}
      {state.step === 'change-password' && (
        <ChangePasswordForm
          username={state.data.username}
          onSuccess={advanceToSuccessStep}
          code={code}
        />
      )}
      {state.step === 'success' && (
        <ConsumerLoginButton
          fullWidth
          size="large"
          color="primary"
          variant="contained"
        >
          Log in
        </ConsumerLoginButton>
      )}
    </Box>
  )
}

export default ForgotPasswordPage
